import { Injectable } from "@angular/core";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceDashboard extends BASEMysqlService {

    prefix = 'dashboard_'
  
    //////////////////////////////////////////////////////////////////////////////////////////
  
  
    get(): Promise<any> {
      let data = {
        auth: this.getAuth(),
      }
    
      return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
    }
  
  
  }